import type TokenTransformerFunc from "@ext/markdown/core/edit/logic/Prosemirror/TokenTransformerFunc";
import getFencedDiagramAttrs from "@ext/markdown/elements/diagrams/logic/getFencedDiagramAttrs";
import isFenceDiagramLang from "@ext/markdown/elements/diagrams/logic/isFenceDiagramLang";

const isGalleryToken = (token, edge: "open" | "close") =>
	token?.type === `gallery_${edge}` || (token?.type === `tag_${edge}` && token.meta?.tag === "gallery");

const isInsideGallery = (tokens: unknown[], index: number) => {
	let depth = 0;
	for (let i = 0; i < index; i++) {
		if (isGalleryToken(tokens[i], "open")) depth++;
		else if (isGalleryToken(tokens[i], "close")) depth--;
	}
	return depth > 0;
};

// A fence becomes a diagram only after ProseMirror has parsed it, and a gallery cannot hold the code block in between.
const galleryFenceTokenTransformer: TokenTransformerFunc = ({ token, tokens, id }) => {
	if (token?.type !== "fence" || !isFenceDiagramLang(token.info) || !isInsideGallery(tokens, id)) return;
	return { type: "diagrams", attrs: getFencedDiagramAttrs(token.info, token.content.replace(/\n$/, "")) };
};

export default galleryFenceTokenTransformer;
